module.exports = __webpack_public_path__ + "img/1.584f4a3f.jpg";